import { render, staticRenderFns } from "./importImg.vue?vue&type=template&id=76dfc6cc&"
import script from "./importImg.vue?vue&type=script&lang=js&"
export * from "./importImg.vue?vue&type=script&lang=js&"
import style0 from "./importImg.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports